/**
 * Season-total follow-up for a matchday ranking page.
 * Never include more than `limit` table rows (plus current user if missing).
 * A goal refresh must not request hundreds of fk_user ids.
 */
export function matchdayRankingFollowUpUserIds (rows, currentUserId, limit) {
  const ids = []
  const seen = Object.create(null)
  const max = limit > 0 ? limit : 0
  if (Array.isArray(rows)) {
    for (let i = 0; i < rows.length && ids.length < max; i++) {
      const u = rows[i] && rows[i].fk_user
      if (u == null || seen[u]) {
        continue
      }
      seen[u] = true
      ids.push(u)
    }
  }
  if (currentUserId && !seen[currentUserId]) {
    ids.push(currentUserId)
  }
  return ids.sort(function (a, b) { return a - b })
}

export function matchdayRankingFollowUpUserQuery (rows, currentUserId, limit) {
  return matchdayRankingFollowUpUserIds(rows, currentUserId, limit).join(',')
}
